module.exports = __webpack_public_path__ + "static/media/iconCanvas06.dbe37c34.svg";